<template>
  <section>
    <div class="container grid">
      <div class="item-title">
        <div class="pill" v-scrollanim>사용방법</div>
        <h2 v-scrollanim>
          별도의 가입 없이<br class="br-xs"><br class="br-xxs">
          다양한 이모티콘을<br class="br-xs">
          사용할 수 있어요
        </h2>
      </div>
      <div class="item-phone">
        <Phone>
          <template v-slot:disclaimer>
            <div class="disclaimer">
              <div class="bullet"></div>
              기기에 따라 순차적으로 업데이트될 예정입니다.
            </div>
          </template>
        </Phone>
      </div>
      <div class="item-subtitle">
        <h3 v-scrollanim>
          더 많은 사람들과<br class="br-xs">
          더 많은 표현을<br class="br-sm"> 함께하다
        </h3>
        <p v-scrollanim>
          더 많은 사람들과 부담 없이 대화하세요.<br>
          어울리는 이모티콘으로 내 감정을<br class="br-sm"> 마음껏 표현할 수 있어요!
          <!-- 메신저 앱이 어려웠던<br class="br-sm"> 더 많은 사람들과 부담 없이<br>
          대화하세요. 어울리는<br class="br-sm"> 이모티콘으로 내 감정을<br>
          마음껏 표현할 수 있어요! -->
        </p>
      </div> 
    </div>
  </section>
</template>

<script>
import Phone from '@/components/phone/Phone'
export default {
  components: {
    Phone
  }
}
</script>

<style lang="scss" scoped>

section {
  --title-font-size: 28px;
  --subtitle-font-size: 24px;
  --copy-font-size: 16px;
  --pill-height: 32px;
  --pill-gutter: 24px;
  --pill-font-size: 14px;
  --pill-push-b: 12px;
  background-color: #F3F3F3;
  padding: 61px 0 130px;

  @media screen and (max-width: 600px) {
    --title-font-size: 22px;
    --subtitle-font-size: 18px;
    --copy-font-size: 14px;
  }
  @media screen and (max-width: 600px) {
    --pill-height: 27px;
    --pill-gutter: 17px;
    --pill-font-size: 12px;
    --pill-push-b: 8px;
    padding: 31px 0 26px;

    
  }
}

.grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin: 0 auto;
  @media screen and (max-width: 540px) {
    padding: 0 20px;
  }
}

.item-title {
  @media screen and (max-width: 600px) {
    grid-column: span 2;
    margin-bottom: 28px;
    text-align: center;
  }
}

.item-phone {
  position: relative;
  grid-row: span 2;
  @media screen and (max-width: 600px) {
    order: 2;
    grid-column: span 2;
  }
}

.item-title h2 {
  font-size: var(--title-font-size);
  font-weight: 700;
  line-height: 1.25;
  color: #171717;
}

.pill {
  height: var(--pill-height);
  padding: 0 var(--pill-gutter);
  border-radius: 24px;
  background-color: #C7D8FF;
  font-size: var(--pill-font-size);
  font-weight: 700;
  color: #7491C7;
  letter-spacing: -0.02em;
  display: inline-flex;
  align-items: center;
  margin: 0 0 var(--pill-push-b);
}

.item-subtitle {
  margin-top: 123px;
  @media screen and (max-width: 600px) {
    margin: 24px 0 0;
    order: 3;
    grid-column: span 2;
    text-align: center;
  }
}

.item-subtitle h3 {
  font-weight: 700;
  font-size: var(--subtitle-font-size);
  color: #363636;
  line-height: 1.3;
  margin: 0 0 13px;
  @media screen and (max-width: 600px) {
    margin: 0 0 8px;
  }
}

.item-subtitle p {
  font-size: var(--copy-font-size);
  line-height: 1.3;
  font-weight: 400;
  color: #797B80;
}

.disclaimer {
  margin: 6px 0 0;
  display: flex;
  align-items: center;
  color: #6F6F6F;
  font-size: 12px;

  .bullet {
    width: 3px;
    height: 3px;
    background-color: currentColor;
    border-radius: 50%;
    margin-right: 8px;
  }
}

// Anims
.pill.before-enter {
  transform: translate3d(0, 200%, 0);
  opacity: 0;
}
.pill.enter {
  transform: translate3d(0, 0, 0);
  opacity: 1;
  transition: 1s transform, 1s opacity;
}

h2.before-enter {
  transform: translate3d(0, 25%, 0);
  opacity: 0;
}
h2.enter {
  transform: translate3d(0, 0, 0);
  opacity: 1;
  transition: 1s transform, 1s opacity;
}


h3.before-enter {
  transform: translate3d(0, 75%, 0);
  opacity: 0;
}
h3.enter {
  transform: translate3d(0, 0, 0);
  opacity: 1;
  transition: 1s transform, 1s opacity;
  transition-delay: 500ms;
}
p.before-enter {
  transform: translate3d(0, 50%, 0);
  opacity: 0;
}
p.enter {
  transform: translate3d(0, 0, 0);
  opacity: 1;
  transition: 1s transform, 1s opacity;
  transition-delay: 1.5s;
}




</style>